const SAVE_SUCCESS_KEY = "ifaRatesSaveSuccess";
const SUCCESS_LIFETIME_MS = 15000;

const normaliseKey = (value) =>
  String(value || "").trim().toLowerCase();

export const storeRatesSaveSuccess = (adviserKeys = [], message = "") => {
  const keys = [...new Set(adviserKeys.map(normaliseKey).filter(Boolean))];
  if (!keys.length || !message) return;

  window.sessionStorage.setItem(
    SAVE_SUCCESS_KEY,
    JSON.stringify({
      keys,
      message,
      expiresAt: Date.now() + SUCCESS_LIFETIME_MS,
    }),
  );
};

export const consumeRatesSaveSuccess = (adviserKeys = []) => {
  const rawValue = window.sessionStorage.getItem(SAVE_SUCCESS_KEY);
  if (!rawValue) return "";

  try {
    const value = JSON.parse(rawValue);
    const keys = adviserKeys.map(normaliseKey).filter(Boolean);
    const matches = keys.some((key) => value.keys?.includes(key));

    if (Number(value.expiresAt) <= Date.now()) {
      window.sessionStorage.removeItem(SAVE_SUCCESS_KEY);
      return "";
    }

    if (!matches) return "";

    window.sessionStorage.removeItem(SAVE_SUCCESS_KEY);
    return String(value.message || "");
  } catch {
    window.sessionStorage.removeItem(SAVE_SUCCESS_KEY);
    return "";
  }
};
